import { useEffect } from "react";

export function useMarkHydration() {
  useEffect(() => {
    window.__isHydrated = true;
  }, []);
}
